import type { ImageProps } from "antd";

import { Image } from "antd";

import { NO_IMAGE } from "@/constants/Global";
import { usePreviewModal } from "@/modules/preview-modal";

const ImageWithPreviewModal = ({ src, ...imageProps }: ImageProps) => {
  const { openPreviewModal } = usePreviewModal();
  const imageSrc = src ?? "error";

  const handlePreview = () => {
    openPreviewModal({ imageSrc });
  };

  return (
    <Image
      {...imageProps}
      src={imageSrc}
      fallback={NO_IMAGE}
      preview={{
        open: false,
        src: imageSrc,
        onOpenChange: () => handlePreview(),
      }}
    />
  );
};

export default ImageWithPreviewModal;
